import { isEmpty } from '@chegg/utils';
import { setAppMode } from '../../AppModeState/AppModeState.actions';
import { AppMode } from '../../AppModeState/AppModeState.types';
/**
 * Util for selected mop view command
 * @param params
 * @returns
 */
export var selectedMopViewCommand = function selectedMopViewCommand(params) {
  var state = params.state,
    dispatch = params.dispatch;
  var selectedMop = state.mopOnFile.selectedMop;
  if (isEmpty(selectedMop)) return;
  dispatch(setAppMode({
    mode: AppMode.REVIEW_MOP,
    goBackMode: AppMode.DEFAULT_MOP
  }));
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/payment-methods/dist/esm/redux/CommandState/commands/selectedMopViewCommand.js
// module id = 4523
// module chunks = 11